import { Pagination } from "services/search";

import { Toll, TollEditFormValues, TollRow } from "./types";
import {
  transformToll,
  transformTollOnCreate,
  transformTollOnUpdate,
  transformTollRow,
} from "./transformations";
import { DataWithPagination } from "services/api/types";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";

/*---------------------------------------------------------------------------------------
 CALCULATION TOLL SEARCH
-----------------------------------------------------------------------------------------*/

export const getTollsAPI = async (
  pagination: Pagination,
  name?: string | null
): Promise<DataWithPagination<TollRow>> => {
  let path = `/v1/expenses/toll?name=`;

  if (name) path += `${name}`;

  return await paginatedApiCall(path, pagination, transformTollRow);
};

/*---------------------------------------------------------------------------------------
    CALCULATION TOLL - BY ID
-----------------------------------------------------------------------------------------*/
export const getTollAPI = async (id: string): Promise<Toll> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/toll/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformToll(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION TOLL - CREATE
-----------------------------------------------------------------------------------------*/
export const createTollAPI = async (
  formValues: TollEditFormValues
): Promise<Toll> => {
  const response = await createApiCall(
    {
      path: "/v1/expenses/toll/",
      method: "POST",
      body: transformTollOnCreate(formValues),
    },
    {
      getMessage: {
        success: () => "Cestarina je uspješno kreirana",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformToll(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION TOLL - UPDATE
-----------------------------------------------------------------------------------------*/
export const updateTollAPI = async (
  id: string,
  formValues: TollEditFormValues
): Promise<Toll> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/toll/${id}`,
      method: "PUT",
      body: transformTollOnUpdate(formValues),
    },
    {
      getMessage: {
        success: () => "Cestarina je uspješno ažuriran",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformToll(response.data);
};

/*---------------------------------------------------------------------------------------
    CALCULATION - TOLL - DELETE
-----------------------------------------------------------------------------------------*/
export const deleteTollAPI = async (id: string): Promise<Toll> => {
  const response = await createApiCall(
    {
      path: `/v1/expenses/toll/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => "Cestarina je uspješno obrisana",
        error: (error: any) => `${transformErrorResponse(error)}`,
      },
    }
  )();

  return transformToll(response.data);
};
